<div class="col-12">
  <div class="card cl-tight">
    <div class="card-header">Encode details</div>
    <div class="card-body">
      <div class="row g-0" [formGroup]="form">
        <div class="col-6 mt-0">
          <label for="input_brefix" class="form-label">Source folder </label>
          <input disabled id="input_brefix" type="text" formControlName="input_brefix">
          @if (form.controls.input_brefix.errors?.required) {
            <p class="invalid-feedback">This field is
            required.</p>
          }
          @if (!form.controls.input_brefix.errors) {
            <p class="valid-feedback">You can
              <a [routerLink]="'/files/browse/' + form.controls.input_brefix.value  ">navigate to the source folder</a>
            </p>
          }
        </div>
        <div class="col-6 mt-0">
          <label for="po_item_id" class="form-label">{{ poItemIdLabel }}<span class="required">*</span></label>
          <input id="po_item_id" type="text" formControlName="po_item_id" pattern="[A-Za-z0-9_\-.]+">
          @if (form.controls.po_item_id.errors?.required) {
            <p class="invalid-feedback">This field is
            required.</p>
          } @else if (form.controls.po_item_id.errors?.pattern) {
            <p class="invalid-feedback">Only letters, numbers, underscores, hyphens, and
            periods are allowed (no spaces).</p>
          } @else if (!form.controls.po_item_id.errors && poItemIdHelp) {
            <p class="valid-feedback">{{ poItemIdHelp }}</p>
          }
        </div>
      </div>
    </div>
  </div>
</div>
